import $ from 'jquery';

function validateForm(formId) {

  // Gte the user date stored in the age gate
  var user_year = localStorage.getItem('user_year') || null;
  var user_day = localStorage.getItem('user_day') || null;
  var user_month = localStorage.getItem('user_month') || null;

  // if(!window.location.href.includes('/fr/')) {
  //   if ($("[name='date_of_birth[items][0][day]']").length && user_day != null) {
  //     $("[name='date_of_birth[items][0][day]']").val(user_day).trigger('keyup');
  //   }
  //   if ($("[name='date_of_birth[items][0][month]']").length && user_month != null) {
  //     $("[name='date_of_birth[items][0][month]']").val(user_month).trigger('keyup');
  //   }
  //   if ($("[name='date_of_birth[items][0][year]']").length && user_year != null) {
  //     $("[name='date_of_birth[items][0][year]']").val(user_year).trigger('keyup');
  //   }  
  // }

  //Set default Country for those we can detect
  var langTag = $('html').attr('lang');
  let defaultCountry = 'United States';

  if (langTag == 'fr') {
    defaultCountry = 'France';
  }
  if (langTag == 'en-gb') {
    defaultCountry = 'United Kingdom';
  }

  //set default country.
  if ($('#edit-country-country').length) {
    $('#edit-country-country').val(defaultCountry).trigger('change');
  }
  if ($('#edit-country-of-residence-country').length) {
    $('#edit-country-of-residence-country').val(defaultCountry).trigger('change');
  }

  const form = document.getElementById(formId);
  const email = document.getElementById('edit-email-address');
  const firstName = document.getElementById('edit-name-first');
  const lastName = document.getElementById('edit-name-last');

  const firstNameContact = document.getElementById('edit-first-name');
  const lastNameContact = document.getElementById('edit-last-name');

  // const month = document.getElementById('edit-date-of-birth-items-0-month');
  const month = document.querySelector("[name='date_of_birth[items][0][month]']")
  const day = document.querySelector("[name='date_of_birth[items][0][day]']");
  const year = document.querySelector("[name='date_of_birth[items][0][year]']");

  // const editCountry = document.querySelector('.edit-country');

  const submitButton = form?.querySelector('#edit-submit');

  submitButton?.setAttribute('disabled', '');

  // let emailAdd = '';
  // let firstNameInput = '';
  // let lastNameInput = '';

  // let firstNameInputContact = '';
  // let lastNameInputContact = '';

  let monthInput = '';
  let dayInput = '';
  let yearInput = '';

  let isMonthValid = false;
  let isDayValid = false;
  let isYearValid = true;

  // Add blur event listeners to add leading zero if needed
  function addLeadingZero(inputField, currentField) {
    console.log(inputField, 'inputFieldinputFieldinputFieldinputField');

    if (
      inputField.value.length === 1 &&
      !isNaN(inputField.value) &&
      inputField.value != 0
    ) {
      inputField.value = inputField.value.padStart(2, '0');
      //focusNextField(currentField, inputField);
    }
  }

  function handleKeyPress(event, field) {
    const key = event.key;

    if (key === 'Backspace') return;

    const currentValue = event.target.value;
    const newValue =
      currentValue.slice(0, event.target.selectionStart) +
      key +
      currentValue.slice(event.target.selectionEnd);

    console.log('newValue', newValue);

    if (field === 'month') {
      if (newValue[0] === '0' && newValue[1] === '0') {
        event.preventDefault();
      } else if (!(newValue >= 0 && newValue <= 12)) {
        event.preventDefault();
      }
    } else if (field === 'day') {
      if (newValue[0] === '0' && newValue[1] === '0') {
        event.preventDefault();
      } else if (!(newValue >= 0 && newValue <= 31)) {
        event.preventDefault();
      }
    }
  }

  // //Day
  // var d = $('#edit-date-of-birth-items-0-day');
  // if (d.length) {
  //   d.on('input', function () {
  //     var vNum = parseInt($(this).val());
  //     if (vNum > 31) {
  //       $(this).val('31');
  //     }
  //   });
  //   d.on('focusout', function () {
  //     var vNum = $(this).val();
  //     if (vNum.length < 2) {
  //       $(this).val('0' + vNum);
  //     }
  //   });
  // }

  // //Month
  // var m = $('#edit-date-of-birth-items-0-month');
  // if (m.length) {
  //   m.on('input', function () {
  //     var vNum = parseInt($(this).val());
  //     if (vNum > 12) {
  //       $(this).val('12');
  //     }
  //   });
  //   m.on('focusout', function () {
  //     var vNum = $(this).val();
  //     if (vNum.length < 2) {
  //       $(this).val('0' + vNum);
  //     }
  //   });
  // }

  month?.addEventListener('input', function (event) {
    monthInput = event.target.value;
    //focusNextField('month', monthInput);
    console.log('Sssssss');
    handleKeyPress(event, 'month');
  });

  month?.addEventListener('keydown', (event) => {
    handleKeyPress(event, 'month');
  });

  day?.addEventListener('keydown', (event) => {
    handleKeyPress(event, 'day');
  });

  day?.addEventListener('input', function (event) {
    dayInput = event.target.value;
    //focusNextField('day', dayInput);
  });

  // year.addEventListener('input', function (event) {
  //   var yearInput = event.target.value;
  //   console.log('yeyeyeyeyeyeyeyyeyeyesss', yearInput.length);
  //   if (yearInput.length >= 4) {
  //     if (
  //       parseInt(year.value) >= 1900 &&
  //       parseInt(year.value) <= new Date().getFullYear()
  //     ) {
  //       isdatevalid(currentField);
  //       isYearValid = true;
  //     } else {
  //       isYearValid = false;
  //       submitButton?.setAttribute('disabled', '');
  //     }
  //   } else {
  //     isYearValid = false;
  //   }
  // });

  year?.addEventListener('input', function () {
    // Remove any non-numeric characters
    let input = this.value.replace(/\D/g, '');

    // Limit to 4 characters
    if (input.length > 4) {
      input = input.slice(0, 4);
    }

    // Automatically format input as 'YYYY'
    this.value = input;

    const inputYear = parseInt(input, 10);
    const currentYear = new Date().getFullYear();

    // Check if the input is a valid year
    if (
      input.length === 4 &&
      (!Number.isInteger(inputYear) ||
        inputYear < 1900 ||
        inputYear > currentYear)
    ) {
      this.setCustomValidity(
        'Please enter a valid year between 1900 and ' + currentYear + '.',
      );
      this.reportValidity();
      submitButton.setAttribute('disabled', true);
    } else {
      this.setCustomValidity('');
    }
  });  

  // email.addEventListener('input', function (event) {
  //   emailAdd = event.target.value;
  // });

  // firstName?.addEventListener('input', function (event) {
  //   firstNameInput = event.target.value;
  // });

  // lastName?.addEventListener('input', function (event) {
  //   lastNameInput = event.target.value;
  // });

  // firstNameContact?.addEventListener('input', function (event) {
  //   firstNameInputContact = event.target.value;
  // });

  // lastNameContact?.addEventListener('input', function (event) {
  //   lastNameInputContact = event.target.value;
  // });

  // Blur event listeners for leading zero
  month?.addEventListener('blur', function () {
    addLeadingZero(month, 'month');
    // focusNextField('month', monthInput);
    // isdatevalid('month')
  });

  day?.addEventListener('blur', function () {
    addLeadingZero(day, 'day');
  });

  year?.addEventListener('blur', function () {
    if (year.value.length === 2 && !isNaN(year.value)) {
      year.value = '20' + year.value; // Assuming the year is in 21st century
    }
  });

  function disableInput() {
    if (isYearValid) {
      month.removeAttribute('disabled');
    } else {
      //month.setAttribute('disabled', '');
      submitButton.setAttribute('disabled', '');
    }
    if (isMonthValid && isYearValid && month) {
      day.removeAttribute('disabled');
    } else {
      //day.setAttribute('disabled', '');
      submitButton.setAttribute('disabled', '');
    }
    if (isMonthValid && isDayValid && month && day) {
      year.removeAttribute('disabled');
    } else {
      //year.setAttribute('disabled', '');
      submitButton.setAttribute('disabled', '');
    }
  }

  function focusNextField(currentField, inputvalue) {
    if (currentField === 'month' && inputvalue) {
      if (month.value.toString().length >= 2) {
        if (parseInt(month.value) >= 1 && parseInt(month.value) <= 12) {
          isdatevalid(currentField);
          isMonthValid = true;
          disableInput();
          setTimeout(() => {
            //day.removeAttribute('disabled');
            day.focus();
          }, 10);
        } else {
          //day.setAttribute('disabled', '');
          isMonthValid = false;
          disableInput();

          submitButton.setAttribute('disabled', '');
        }
      } else {
        isMonthValid = false;
        disableInput();
      }
    } else if (currentField === 'day' && inputvalue) {
      if (day.value.toString().length >= 2) {
        isdatevalid(currentField);
        isDayValid = true;
      } else {
        isDayValid = false;
        disableInput();

        submitButton.setAttribute('disabled', '');
      }
    } else if (currentField === 'year' && inputvalue) {
      if (year.value.toString().length >= 4) {
        if (
          parseInt(year.value) >= 1900 &&
          parseInt(year.value) <= new Date().getFullYear()
        ) {
          isdatevalid(currentField);
          isYearValid = true;
          disableInput();
        } else {
          isYearValid = false;
          disableInput();

          submitButton.setAttribute('disabled', '');
        }
      }
      else {
        isYearValid = false;
        disableInput();
      }
    }
  }

  function isdatevalid(currentField) {
    let maxDayOfMonth = 31;
    const selectedMonth = parseInt(month.value);
    if (
      parseInt(selectedMonth) >= 1 &&
      parseInt(selectedMonth) <= maxDayOfMonth
    ) {
      isMonthValid = true;
    } else {
      isMonthValid = false;
    }
    if (selectedMonth === 2) {
      const isLeapYear =
        year.value % 4 === 0 &&
        (year.value % 100 !== 0 || year.value % 400 === 0);
      if (isLeapYear) {
        maxDayOfMonth = 29;
      } else {
        maxDayOfMonth = 28;
      }
    } else if ([4, 6, 9, 11].includes(selectedMonth)) {
      maxDayOfMonth = 30;
    }
    if (day.value) {
      if (parseInt(day.value) >= 1 && parseInt(day.value) <= maxDayOfMonth) {
        isDayValid = true;

        if (currentField === 'day') {
          if (day.value.toString().length >= 2) {
            //year.removeAttribute('disabled');
            setTimeout(() => {
              year.focus();
            }, 10);
          }
        }
      } else {
        isDayValid = false;
        year.setAttribute('disabled', '');
      }
    }
  }

  if (form != null) {
    const submitButton = document.getElementById('edit-submit');
    submitButton.disabled = true;

    function validate() {
      // Get all required inputs
      const requiredFields = form.querySelectorAll('[required]');
      let valid = true;

      requiredFields.forEach((field) => {
        if (!field.value.trim()) {
          valid = false;
        }
        else if (field.type === 'email') {
          // Validate email format
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailPattern.test(field.value)) {
            valid = false;
          }
        }
        else if (field.getAttribute('id') == 'edit-date-of-birth-items-0-year') {
          const currentYear = new Date().getFullYear();  
          const regex = new RegExp(`^(19[0-9]{2}|20[0-${Math.floor(currentYear / 100) % 10}][0-9]|${currentYear})$`);
          if (regex.test(field.value)) {
            valid = true;
          }
        }
      });

      return valid;
    }

    // Run this check straight away to see if a pre-filled form is already valid
    // if (validate()) {
    //   if (
    //     !month.hasAttribute('disabled') &&
    //     !day.hasAttribute('disabled') &&
    //     !year.hasAttribute('disabled')
    //   ) {
    //     submitButton.disabled = false;
    //   }
    // } else {
    //   submitButton.disabled = true;
    // }

    // Now listen for interaction with the form
    form.addEventListener('input', function () {
      if (validate()) {
        console.log(month.hasAttribute('disabled'), 'month.hasAttribute');

        if (
          !month.hasAttribute('disabled') &&
          !day.hasAttribute('disabled') &&
          !year.hasAttribute('disabled')
        ) {
          submitButton.disabled = false;
        }
      } else {
        submitButton.disabled = true;
      }
    });

    form.addEventListener('submit', function (event) {
      if (!validate()) {
        event.preventDefault(); // Prevent form submission if invalid
        alert('form not valid...');
      }
    });
  }
}

export default validateForm;
